// 该文件仅封装请求，get，post，upLoadFile，登录token的维护，请求中涉及的遮罩，独立文件引入，以便兼容各个平台
import axios from "axios";
import qs from "qs";
import common from "./common";
import {
  _getEvn,
  _getSuccessCode,
  _getLoginOutCode,
  _getNoPowerCode,
  _getNoPowerCodeComSelect,
  _getNoPowerUrl,
  _getNoPowerComSelectUrl,
  _getTestUserId,
  _getLoginAuthorizeUrl,
  _getResCodeAndErrMsg,
  _getCaptchaCode
} from "./config.js";

// 跳转到登录页面
const redirectLogin = res => {
  // 授权登录url，部分項目返回的数据结构不一致，通过方法获取，在config.js里面配置
  const finallUrl = _getLoginAuthorizeUrl(res);
  console.log("登录地址", finallUrl);
  if (_getEvn() !== "development") {
    window.location.replace(finallUrl);
  }
};

// 跳转到无权限页面
// eslint-disable-next-line no-unused-vars
const redirectNoPower = res => {
  console.log("无权限页面", _getNoPowerUrl());
  if (_getEvn() !== "development") {
    window.location.href = _getNoPowerUrl();
  }
};

// 跳转到无权限页面,特定页面
// eslint-disable-next-line no-unused-vars
const redirectNoPowerComSelect = res => {
  console.log("无权限页面", _getNoPowerComSelectUrl());
  if (_getEvn() !== "development") {
    window.location.href = _getNoPowerComSelectUrl();
  }
};

// 兼容token或者session模式
export default ({
  url,
  data = {},
  noLoading = false,
  file = null,
  method = "POST",
  retuenReject = false,
  timeout = null,
  contentType = ""
}) => {
  // 部分项目test调试
  if (_getEvn() === "development" && _getTestUserId().length > 0) {
    url += "&test=" + _getTestUserId();
  }
  return new Promise((resolve, reject) => {
    // console.log(common._getTerminalMsg());
    // token 值
    let projectNameArray = window.location.pathname.split("/");
    let projectName = (projectNameArray[1] || "") + "token";
    let {
      isWX,
      isMobile,
      isPC
    } = common._getTerminalMsg();
    if (!noLoading) {
      if (isMobile || isWX) {
        common.mbToastLoading();
      } else if (isPC) {
        common.pcToastLoading();
      } else {
        console.log("XXX组件加载中");
      }
    }
    // 关键步骤：仅在显式指定 JSON 时保留对象结构，默认行为仍保持表单提交流程。
    const requestContentType = file
      ? "multipart/form-data"
      : contentType || "application/x-www-form-urlencoded";
    const requestData = file
      ? file
      : requestContentType === "application/json"
      ? data
      : qs.stringify(data);

    axios({
        method: method,
        url: url,
        data: requestData,
        headers: {
          Authorization: common.getToken(),
          "Content-Type": requestContentType
        },
        params: ["get", "GET"].includes(method) ? data : {}
      })
      .then(res => {
        if (!noLoading) {
          if (isMobile || isWX) {
            common.mbToastClose();
          } else if (isPC) {
            common.pcToastClose();
          } else {
            console.log("XXX组件取消加载");
          }
        }
        let {
          code,
          errmsg
        } = _getResCodeAndErrMsg(res);
        console.log(code, _getLoginOutCode(res));
        if (code === _getSuccessCode()) {
          resolve(res);
        } else if (code === _getLoginOutCode(res)) {
          // window.localStorage.removeItem("token");
          window.localStorage.removeItem(projectName);
          redirectLogin(res);
          if (process.env.NODE_ENV === 'development') {
            resolve(res);
          }
          reject(res);
        } else if (code === _getNoPowerCodeComSelect(res)) {
          // 记录当前页面地址
          let noPowerReturnUrl = window.location.href;
          window.localStorage.setItem("noPowerReturnUrl", noPowerReturnUrl);
          redirectNoPowerComSelect(res);
          reject(res);
        } else if (code === _getNoPowerCode(res)) {
          // 记录当前页面地址
          // let noPowerReturnUrl = window.location.href;
          // window.localStorage.setItem("noPowerReturnUrl", noPowerReturnUrl);
          redirectNoPower(res);
          reject(res);
        } else if (code === _getCaptchaCode(res)) {
          if (isMobile || isWX) {
            common.mbToastClose();
            common.mbToastFail(errmsg);
          } else if (isPC) {
            common.pcToastClose();
            common.pcToastFail(errmsg);
          } else {
            alert(errmsg);
          }
          resolve(res);
        } else {
          if (retuenReject) {
            resolve(res);
          } else {
            if (isMobile || isWX) {
              common.mbToastFail(errmsg);
            } else if (isPC) {
              common.pcToastFail(errmsg);
            } else {
              alert(errmsg);
            }
            reject(res);
          }
        }
      })
      .catch(e => {
        console.log("axios error", e);
        if (e.response && e.response.status === 504 && timeout){
          timeout(e);
          return;
        }
        if (isMobile || isWX) {
          common.mbToastClose();
          common.mbToastFail(e.toString());
        } else if (isPC) {
          common.pcToastClose();
          common.pcToastFail(e.toString());
        } else {
          alert(e);
        }
        // 上传错误日志
      })
      .finally(() => {});
  });
};
